import React from "react";
import {EmailConfigurationType, EmailProcessingResultType} from "./types";
import {Action} from "./actions";


type Dispatch = (action: Action) => void
type State = {
    configuration: EmailConfigurationType
    result: EmailProcessingResultType

}

export const ApplicationContext = React.createContext<{ state: State; dispatch: Dispatch } | undefined>(undefined)

const applicationReducer = (state: State, action: Action): State => {
    switch (action.type) {
        case "updateConfiguration": {
            return {...state, configuration: action.value}
        }
        case "startUpdate": {
            return {
                ...state,
                result: {
                    ...(state.result),
                    inProgress: true,
                    error: null,
                    alerts: []
                }
            }
        }
        case "updateCompleted": {
            return {
                ...state,
                result: {
                    ...(state.result),
                    inProgress: false,
                    error: null,
                    body: action.value.body,
                    alerts: action.value.alerts
                }
            }
        }
        case "updateFailed": {
            return {
                ...state,
                result: {
                    ...(state.result),
                    inProgress: false,
                    error: action.value.error,
                    alerts: action.value.alerts
                }
            }
        }
        default: {
            // @ts-ignore
            throw new Error(`Unhandled action type: ${action.type}`)
        }
    }
}

export const ApplicationProvider: React.FC<{ initialValue: State, children: React.ReactNode }>
    = ({initialValue, children}) => {

    const [state, dispatch] = React.useReducer(applicationReducer, initialValue)
    // NOTE: you *might* need to memoize this value
    // Learn more in http://kcd.im/optimize-context
    const value = {state, dispatch}
    return <ApplicationContext.Provider value={value}>{children}</ApplicationContext.Provider>
}

export const useApplicationContext = () => {
    const context = React.useContext(ApplicationContext)
    if (context === undefined) {
        throw new Error('useApplicationContext must be used within a ApplicationProvider')
    }
    return context
}

